import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SharedDataService } from '../../services/shared-data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { saveAs } from 'file-saver';



function cropYearsList() {
  const currentYear = new Date().getFullYear();

  // Calculate the range of years
  const startYear = currentYear - 1;
  // const endYear = currentYear + 5;
  const endYear = currentYear;

  // Create an array to store the years
  const yearsArray = [];

  // Populate the array with years
  for (let year = startYear; year <= endYear; year++) {
    yearsArray.push(year);
  }

  return yearsArray;

}

export const yearLists: any = cropYearsList();

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {


  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  @Input() title: string = '';
  @Input() addAddress: string = '';
  @Input() displayedColumns: any[] = [];
  @Input() list: any[] = [];
  @Input() url: string = '';
  @Input() deleteUrl: string = '';
  @Input() id: string = '';
  @Input() action: boolean = false;
  @Input() isDate: boolean = false;
  @Input() deleteIsUtilizedBin = '';
  @Input() isUtilization: boolean = false;
  @Input() isLocation: boolean = false;
  @Input() isTypeFilter: boolean = false;
  @Input() addBtn: boolean = true;
  @Input() isAtiveFilter: boolean = true;
  @Input() exportExcel: boolean = false;
  @Input() isGodown: boolean = false;
  @Input() isDownloadBtnShow: boolean = false;
  isLoading: boolean = false;
  notFound: boolean = false;
  dataSource = new MatTableDataSource<any>([]);
  filter: any = 'active';
  warehouses: any[] = [];
  locationId: any = '';
  objInformation: any = {};
  typefilter = '';
  yearsLists: any[] = [];
  year = new Date().getFullYear();
  sortedData: any[] = [];
  godownlists: any[] = [];
  godownId: any = "";
  @Input() cropYearShow: boolean = false;
  constructor(public dialog: MatDialog, private _liveAnnouncer: LiveAnnouncer, private router: Router,
    private sharedService: SharedService, public sharedDataService: SharedDataService,  private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    if (this.action) {
      this.displayedColumns.push('Action')
    }
    this.fetchList();
    if (this.isLocation) {
      this.fetchWarehouses();
    }

    // if (this.isGodown) {
    //   this.getAllGodowns();
    // }
    if (this.cropYearShow) {
      this.cropYears();
    }

    this.sharedService.refresh.asObservable().subscribe(res => {
      if (res) {
        this.fetchList();
      }
    });

  }

  fetchList() {
    this.isLoading = true;
    console.log(this.url);
    // let urlInfo = '';
    // urlInfo = this.url + `?statusFilter=${this.filter}`;
    if (this.isAtiveFilter) {
      this.objInformation.statusFilter = this.filter;
    }

    if (this.cropYearShow) {
      this.objInformation.year = this.year;
    }
    this.sharedService.getListsInfo(this.url, this.objInformation).subscribe((res: any) => {
      this.isLoading = false;
      if (res.code === 200) {
        if (res.data.length <= 0) {
          this.notFound = true;
        }
        if (this.isDate) {
          res.data.map((el: any) => {
            el.dispatchDate = new Date(el.dispatchDate).toLocaleDateString()
          })
          console.log(res.data)
        }
        res.data.map((el: any) => {
          el.isActive = el.isActive ? 'Yes' : 'No';
          el.isWarehouse = el.isWarehouse ? 'Yes' : 'No';
          el.isBuyingCenter = el.isBuyingCenter ? 'Yes' : 'No';
          el.CPAFlag = el.CPAFlag ? 'Yes' : 'No';
          el.NTRMStatus = el.NTRMStatus ? 'Yes' : 'No';
          el.isPBM = el.isPBM ? 'Yes' : 'No';

        })
        this.dataSource = new MatTableDataSource<any>(res?.data);
        this.dataSource.sort = this.sort;
        this.sortedData = res?.data.slice();
        this.dataSource.paginator = this.paginator;
      } else {
        this.sharedService.showMessage(res.message);
      }


    }, err => {
      this.sharedService.showMessage(err.message);
    });
  }

  getId(row: any) {
    return row[this.id] || 0;
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    console.log(sortState);

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  navigateToAdd() {
    this.router.navigateByUrl(this.addAddress);
  }

  delete(id: string) {
    // this.dialog.open(ConfirmDialogComponent, {
    //   width: '450px',
    // });




    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { url: this.deleteUrl, id: id, isUtilization: this.isUtilization, deleteIsUtilizedBin: this.deleteIsUtilizedBin },
      width: '450px',
    });
    // const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //   data: {name: this.name, animal: this.animal},
    // });


    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result != 'no') {
        this.fetchList();
      }

    });
  }

  changeCropyear(e: any) {
    // this.cropYear = e.value;
    // this.getList(this.cropYear);
    if (e == 'location') {
      this.objInformation.locationId = this.locationId;
      this.godownlists = [];
      this.godownId = 'All';
      delete this.objInformation.godownId;
      this.fetchGodowns(this.locationId);
    }
    if (e == 'typeFilter') {
      this.objInformation.typeFilter = this.typefilter;
    }


    if (e == 'godown') {
      this.objInformation.godownId = this.godownId;
    }

    if (e == 'year') {
      this.objInformation.year = this.year;
    }

    this.fetchList();

  }

  fetchWarehouses() {
    this.sharedService.getWarehousesPbm().subscribe(res => {
      this.warehouses = res.data.filter((f: any) => f.WarehouseName);
    }, err => {
      this.sharedService.showMessage(err.message);
    })
  }


  getAllGodowns() {
    this.sharedService.getAllGodowns().subscribe(res => {
      this.godownlists = res.data.filter((f: any) => f.warehouseName != null);
    }, err => {
      this.sharedService.showMessage(err.message);
    })
  }
  cropYears() {
    const currentYear = new Date().getFullYear();

    // Calculate the range of years
    const startYear = currentYear - 1;
    // const endYear = currentYear + 5;
    const endYear = currentYear;

    // Create an array to store the years
    const yearsArray = [];

    // Populate the array with years
    for (let year = startYear; year <= endYear; year++) {
      yearsArray.push(year);
    }

    this.yearsLists = yearsArray;
    console.log(this.yearsLists);

  }

  exportDataToExcel() {
    this.sharedDataService.exportToExcel(
      this.dataSource.data,
      'data-export'
    );
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Contract ID':
          return compare(a.name, b.name, isAsc);
        case 'calories':
          return compare(a.calories, b.calories, isAsc);
        case 'fat':
          return compare(a.fat, b.fat, isAsc);
        case 'carbs':
          return compare(a.carbs, b.carbs, isAsc);
        case 'protein':
          return compare(a.protein, b.protein, isAsc);
        default:
          return 0;
      }
    });
  }

  fetchGodowns(event: any) {
    if (event) {
      this.sharedService.getGodownByLocation(event).subscribe(res => {
        this.godownlists = res?.data;
      }, err => {
        this.sharedService.showMessage(err.message);
      })
    }
  }

onDownload() {
  const payload: any = {};
  
  let apiURL: string = "";
  if(this.url == "COIDescription/getAllCOIDescriptionDataByYear"){
    apiURL = 'Reports/Report/GetCOIDataDownload';
  }else if(this.url == "CPA/getAllCPAByYear"){
    apiURL = 'Reports/Report/GetCPADataDownload'
  }else if(this.url == "CropQuotaYear/getAllCropQuotaByYear") {
    apiURL = 'Reports/Report/GetQoutaDataDownload'
  }
  // const apiURL: string = 'Reports/Report/GetCOIDataDownload';
  payload.cropYear = this.objInformation.year;
  payload.format = 'excel';
  this.isLoading = true


  this.sharedDataService.downloadExcelFile(payload, apiURL).subscribe((res: any) => {
      if (res  && res.type =='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {

        this.isLoading = false
        this.sharedDataService.loaderTrigger.next(false);
        const file = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        if(this.url == "COIDescription/getAllCOIDescriptionDataByYear"){
          saveAs(file, `COI-Data-Export-${new Date().toDateString()}`);
        }else if(this.url == "CPA/getAllCPAByYear"){
          saveAs(file, `CPA-Data-Export-${new Date().toDateString()}`);
        }else if(this.url == "CropQuotaYear/getAllCropQuotaByYear") {
          saveAs(file, `Quota-Data-Export-${new Date().toDateString()}`);
        }
        // saveAs(file, `COI-Data-Export-${new Date().toDateString()}`);

      } else {
        this.isLoading = false
        this.sharedDataService.loaderTrigger.next(false);
        this._snackBar.open('No Records Found.', 'Close', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 6000,
        });
      }
    }, err => {
      this.sharedDataService.loaderTrigger.next(false);
      this.isLoading = false

      this._snackBar.open(err.error.message || err.message || 'Server Side Error', 'Close', {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 6000,
      });
  });
}
}
